export const convertFromUtf16 = (utf16 : any) => String.fromCodePoint(...utf16.split("-").map(u => `0x${u}`));